/**
 * What one calendar day of a timesheet can hold.
 *
 * A day was capped nowhere. Two entries of 23h 59m on the same date both saved,
 * and the day printed 47h 58m with the weekly total, the daily average and the
 * "of 40h" bar all following it into Team Time, the reports and the billed
 * figure (the Reports tab's Invoiced hours then, Billable Hours since HW-973).
 * The API refuses such a write now; this is the other half — the days already
 * stored that way stay stored, and a total that cannot be true should not be
 * printed in the same ink as one that can. [HW-859]
 *
 * Read against the row's OWN total. Since [HW-916] the Weekly Timesheet and
 * the server partition by the same day — the author's own, which the stored
 * UTC digits name — so for a converted row the timesheet's day IS the day the
 * server caps, whoever is looking. Before that the timesheet grouped by the
 * viewer's local day [HW-858] while the server capped the UTC one, and a local
 * day could hold more than 24 hours with each UTC day inside it legal.
 *
 * That split survives for legacy rows (null zone) until the backfill converts
 * them, and for any a stale tab writes afterwards: their `startedAt` is still a
 * real instant, the timesheet buckets it by the viewer's day, and the server
 * caps its UTC day. The server also never capped timer or imported rows. So a
 * marked row is still NOT the same claim as "the server would have refused
 * this"; this is deliberately a remark about the total on screen, not a second
 * copy of the server's rule.
 */

export const MAX_DAY_SECONDS = 24 * 60 * 60;

/** More time on one day than a day has. */
export function isDayOverfull(totalSeconds: number): boolean {
  return totalSeconds > MAX_DAY_SECONDS;
}

/**
 * Said on the day's own total, where the number is.
 *
 * Names the ceiling rather than the excess: the reader can subtract, and what
 * they need is the reason the figure is marked at all.
 */
export const OVERFULL_DAY_HINT = 'More than the 24 hours a day holds — shorten or remove an entry.';
